// extracted by mini-css-extract-plugin
module.exports = {"header":"restaurantMapPage_header__Sde6E","container":"restaurantMapPage_container__ftOmg","innerContainer":"restaurantMapPage_innerContainer__yI5sp"};